import React from 'react'
import Swal from 'sweetalert2'
export default function Alert() {
  
  return (
    <div>Alert</div>
  )
}
